import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

const Home = (props) =>
  <div>
    <Helmet>
      <title>OTC CMS | Home</title>
    </Helmet>
    <h3>Home</h3>
    <ul>
      <li><Link to='/pages'>Root Pages</Link></li>
      <li><Link to='/recent-pages'>Recent Pages</Link></li>
      <li><Link to='/files'>List All Files</Link></li>
      <li><Link to='/documents'>List Documents</Link></li>
      <li><Link to='/images'>List Images</Link></li>
      <li><Link to='/users'>List Users</Link></li>
      <li><Link to='/settings'>Settings</Link></li>
    </ul>
    <hr />
  </div>

export default Home



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js